<template>
  <div class="videoPlayer">
    <div class="title" v-text="msgs.VideoTitle"></div>
    <div class="msg-box">
      <span>{{datas.VideoCreateTime | times}}</span>
    </div>
    <div class="video-box">
      <VideoM3U8 v-if="datas.videoUrl.includes('.m3u8')" :videoUrl="datas.videoUrl" />
      <video
        v-else
        :src="datas.videoUrl"
        :poster="msgs.VideoImage | img2"
        autoplay
        controls="controls"
        id="_video"
      />
    </div>
  </div>
</template>

<script>
import VideoM3U8 from '@/components/VideoM3U8/index'

import { getVideoDetail } from '@/api/common.js'

export default {
  components: { VideoM3U8 },
  data() {
    return {
      videoUrl: 'http://hls.cntv.lxdns.com/asp/hls/main/0303000a/3/default/aa24943d141b4b9ea2e29e4583f8f79e/main.m3u8?maxbr=2048',
      videoPoster: '',
      datas: {
        videoUrl: ""
      },
      fours: [
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy16.png"),
          title: "平“语”近人",
          source: "共产党员网·2018.02.03"
        },
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy17.png"),
          title: "听学新思想",
          source: "共产党员网·2018.02.03"
        }
      ],
      vedioArray: [],
      vedioIndex: 0,
      msgs:{
      }
    };
  },
  methods: {
    goDetail() {
      this.$router.push({
        path: "/boutique/videoPlayer",
        query: { title: "视频播放" }
      });
    },
    getMsg() {      
      const sourse = JSON.parse(this.$route.query.source)
      // console.log('sourse', sourse);
      
      this.vedioArray = sourse.VideoPath.split("|");
      this.datas.videoUrl = this.vedioArray[this.vedioIndex];
      this.msgs = sourse
      // add video integral
      const userid = Number(sessionStorage.getItem('id'))
      const params = {
        Vid: Number(this.msgs?.Vid || 0),
        uid: userid
      }
      getVideoDetail(params)
    },
    videoPlayer() {
      let _video = document.querySelector("#_video");
      if (!_video) return
      _video.addEventListener("ended", () => {
        if (this.vedioIndex != this.vedioArray.length - 1) {
          this.vedioIndex++;
          this.datas.videoUrl = this.vedioArray[this.vedioIndex];
          _video.addEventListener("loadstart",()=>{
            _video.play()
          })
        }
      });
    },
    makeFooter(){
      this.axios.post(
        '/api/Main/addFootmark',
        {
          name:'我的视频足迹',
          token:sessionStorage.getItem('token'),
          loginname:this.msgs.VideoTitle,
          town:window.location.href
        }
      )
    }
  },
  mounted() {    
    this.getMsg();
    this.videoPlayer();
    this.makeFooter()
  }
};
</script>

<style lang="scss" scoped>
.videoPlayer {
  .other-video {
    .class-box {
      .class-template {
        &:nth-child(odd) {
          margin-right: 2%;
        }
        img {
          width: 100%;
        }
        p {
          &:nth-child(3) {
            color: #999999;
          }
          line-height: 2;
          padding: 0 0.2rem;
          font-size: 0.26rem;
        }
        width: 49%;
        background: #fff;
        margin-top: 0.3rem;
        padding-bottom: 0.2rem;
      }
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      padding: 0 0.2rem;
    }
    .title {
      span {
        font-weight: bold;
        font-size: 0.36rem;
      }
      img {
        width: 0.38rem;
        height: 0.45rem;
        margin-right: 0.1rem;
      }
      display: flex;
      align-items: center;
      background: #fff;
      line-height: 3;
    }
    margin-top: 0.3rem;
  }
  .video-box {
    width: 100%;
    height: 4rem;
    padding: 0 0.2rem;
    margin-top: 0.3rem;
    text-align: center;
    video {
      width: 100%;
    }
  }
  .msg-box {
    span {
      &:nth-child(1) {
        color: #999999;
      }
      &:nth-child(2) {
        margin-left: 50%;
      }
      img {
        width: 0.23rem;
        height: 0.23rem;
      }
    }
    padding: 0 0.2rem;
  }
  .title {
    line-height: 2;
    font-weight: bold;
    font-size: 0.36rem;
    padding: 0 0.2rem;
  }
  padding-top: 1.2rem;
  font-size: 0.3rem;
}
</style>